import { Alert, Slide, SlideProps, Snackbar, SnackbarCloseReason } from "@mui/material";
import { useSnackbar } from "../contexts/SnackbarContext";

export default function NotificationSnackbar() {
  const { snackbar, snackbarDispatch } = useSnackbar()

  function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="up" />;
  }

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    snackbarDispatch({ type: 'clearSnackbar' });
  };

  return (
    <>
      <Snackbar
        open={Boolean(snackbar?.message)}
        autoHideDuration={6000}
        onClose={handleClose}
        slots={{ transition: SlideTransition}}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right'}}
      >
        <Alert 
          onClose={handleClose}
          severity={snackbar?.error === true ? 'error' : 'success'}
          variant="filled"
          sx={{width: '100%'}}
        >
          {snackbar?.message}
        </Alert>
      </Snackbar>
    </>
  )
}